module.exports = __webpack_public_path__ + "static/media/1015201.ad9b032d.jpg";